import React from 'react'
import { Button } from "@progress/kendo-react-buttons";
import { Badge, BadgeContainer } from '@progress/kendo-react-indicators';

const BulkLogButton = (props: BulkLogButtonProps) => {
    return (
        <BadgeContainer>
            <Button icon="aggregate-fields" onClick={props.onClick} formNoValidate={true} title={'Toggle Bulk Logging'} type='button' />
            {props.badgeCount > 0 && <Badge className='ml-1' size='small' align={{ horizontal: "start", vertical: "top" }}><span>{props.badgeCount}</span></Badge>}
        </BadgeContainer>
    )
}

type BulkLogButtonProps = {
    ticketPhrase?: string
    onClick: () => void
    badgeCount: number
}
export default BulkLogButton